import React from "react"
import styled from "@emotion/styled/macro"
import { theme, device } from "./Theme"
import {
  GatsbyImage,
  getImage,
  withArtDirection,
  StaticImage,
} from "gatsby-plugin-image"
import { Form } from "./Form"
import { Link } from "gatsby"

function ContactImage(props) {
  const images = withArtDirection(getImage(props.mobileImage), [
    {
      media: device.lg,
      image: getImage(props.desktopImage),
    },
  ])
  return <GatsbyImage className="backgroundImage" image={images} />
}

const Footer = props => {
  const ContactFooterContainer = styled.footer`
    background-color: ${theme.colors.dark};
    color: ${theme.colors.light};
    padding-bottom: 2.8125rem;

    .contact {
      display: grid;
      text-align: center;
    }
    .backgroundImage {
      grid-area: 1/1;

      @media ${device.lg} {
        aspect-ratio: 1920/1367;
      }
    }
    .textAndFormContainer {
      grid-area: 1/1;
      z-index: 1;
      width: 90%;
      margin: 0 auto 20rem auto;
      max-width: 1026px;

      @media ${device.lg} {
        margin: 0 auto;
      }
    }
    .bottomFooter {
      margin: 0 auto;
      width: 90%;
      max-width: 1393px;
      color: ${theme.colors.footer};
    }
    .bottomFooter a {
      color: ${theme.colors.footer};
      transition: all 0.25s;

      &:hover {
        color: ${theme.colors.light};
      }
    }
    .infoContainer {
      @media ${device.lg} {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 4.0625rem;
      }
    }
    .links ul {
      list-style-type: none;
    }
    .logoAndText {
      text-align: center;
      color: ${theme.colors.light};

      @media ${device.lg} {
        text-align: left;
      }
    }
    .logoAndText p {
      margin: 1.8125rem 0 3.6875rem 0;
      font-size: 1.125rem;
      line-height: 1.5;
    }
    .footerTitle {
      font-weight: 700;
      font-size: clamp(1.5rem, 1.4545rem + 0.1942vw, 1.6875rem);
      margin: 3.9375rem 0 1.625rem 0;
      color: ${theme.colors.light};

      @media ${device.lg} {
        margin: 0 0 1.625rem 0;
      }
    }
    .links .footerTitle {
      margin: 0 0 1.625rem 0;
    }
    .hoursLicensesContainer .footerTitle {
      margin: 1.71875rem 0 1.4375rem 0;
      @media ${device.lg} {
        margin: 0 0 1.625rem 0;
        line-height: 1;
      }
    }
    .links div {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .contactInfoContainer {
      border-bottom: 1px solid ${theme.colors.footer};
      padding: 1rem 0;

      @media ${device.lg} {
        border-bottom: none;
      }

      a {
        display: grid;
        grid-template-columns: 73px 2fr;
        color: ${theme.colors.light};
        margin: 1rem 0;
        line-height: 1.3rem;
        transition: all 0.25s;
        .address,
        .phoneNumber {
          color: ${theme.colors.footer};
        }
        &:hover {
          .address,
          .phoneNumber {
            color: ${theme.colors.light};
          }
        }
      }
    }
    .contactInfoContainer:first-of-type {
      padding: 0 0 1rem 0;

      @media ${device.lg} {
        padding: 0;
      }
    }
    .contactInfoContainer:last-of-type {
      border-bottom: none;
    }
    .hoursLicensesContainer {
      display: grid;
      grid-template-columns: 1fr 1fr;
      line-height: 1.5;

      @media ${device.lg} {
        display: block;
      }
    }
    .socialMedia {
      display: grid;
      grid-template-columns: repeat(3, 2.4375rem);
      justify-content: center;
      grid-column-gap: 0.75rem;
      margin: 3.9375rem 0 2.25rem 0;
      a {
        &:hover {
          & g {
            stroke: ${theme.colors.light};
          }
          & path {
            fill: ${theme.colors.light};
          }
        }
      }
    }
    .copyright {
      text-align: center;
      line-height: 1.5;
    }
    .nexvel {
      text-align: center;
      margin-top: 2rem;
    }
    .licenses {
      .footerTitle {
        @media ${device.lg} {
          margin: 1.625rem 0;
        }
      }
    }
  `
  return (
    <ContactFooterContainer>
      <div className="contact">
        <ContactImage
          mobileImage={props.contactData.backgroundImageMobile}
          desktopImage={props.contactData.backgroundImageDesktop}
          alt={props.contactData.altText}
        />
        <div className="textAndFormContainer">
          <Form data={props.contactData} />
        </div>
      </div>
      <div className="bottomFooter">
        <div className="infoContainer">
          <div className="logoAndText">
            <Link to="/">
              <GatsbyImage image={props.data.logo} alt="logo" />
            </Link>
            <p>{props.data.text}</p>
          </div>
          <div className="links">
            <p className="footerTitle">{props.data.section1Title}</p>
            <div>
              <ul>
                {props.data.mainMenu.map(menuItem => {
                  return (
                    <li key={menuItem.index}>
                      <Link to={menuItem.path}>{menuItem.label}</Link>
                    </li>
                  )
                })}
              </ul>
              <ul>
                {props.data.topBarMenu.map(menuItem => {
                  return (
                    <li key={menuItem.index}>
                      <Link to={menuItem.path}>{menuItem.label}</Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
          <div className="contactBottomFooter">
            <p className="footerTitle">{props.data.section2Title}</p>
            {props.data.contactInfo.map(contact => {
              return (
                <div className="contactInfoContainer">
                  <a href={contact.addressLink} target="_blank">
                    <p className="label">{contact.addressLabel}</p>
                    <div
                      className="address"
                      dangerouslySetInnerHTML={{ __html: contact.address }}
                    />
                  </a>
                  <a href={`tel:` + contact.phoneNumber}>
                    <p className="label">{contact.phoneLabel}</p>
                    <p className="phoneNumber">{contact.phoneNumber}</p>
                  </a>
                </div>
              )
            })}
          </div>
          <div className="hoursLicensesContainer">
            <div className="hours">
              <p className="footerTitle">{props.data.section3Title}</p>
              <div
                dangerouslySetInnerHTML={{ __html: props.data.section3Text }}
              />
            </div>
            <div className="licenses">
              <p className="footerTitle">{props.data.section4Title}</p>
              <div
                dangerouslySetInnerHTML={{ __html: props.data.section4Text }}
              />
            </div>
          </div>
        </div>
        <div className="socialMedia">
          {props.data.socialMedia.map(social => {
            return (
              <a href={social.link} target="_blank">
                <div dangerouslySetInnerHTML={{ __html: social.icon }} />
              </a>
            )
          })}
        </div>
        <div
          className="copyright"
          dangerouslySetInnerHTML={{ __html: props.data.copyright }}
        />
        <div className="nexvel">
          <a href="https://www.nexvelsolutions.com/" target="_blank">
            <StaticImage
              src="../images/SVGs/nexvel-logo.svg"
              alt="Nexvel Solutions logo"
            />
          </a>
        </div>
      </div>
    </ContactFooterContainer>
  )
}
export { Footer }
